import { Static, Object, Optional } from '@sinclair/typebox';

import { AirportPartnerOperatedNetwork, CityMap } from '../../sas-domain/airports';

export const PartnerAwardLocationsQueryParams = Object({
  partner: Optional(AirportPartnerOperatedNetwork),
});
export type PartnerAwardLocationsQueryParams = Static<typeof PartnerAwardLocationsQueryParams>;

export const PartnerAwardLocationsResponse = CityMap;
export type PartnerAwardLocationsResponse = Static<typeof PartnerAwardLocationsResponse>;
